import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { LkpStoresModel } from 'src/app/models/LkpStoresModel';
import { LkpStoresService } from 'src/app/services/LkpStoresService';


@Component({
  selector: 'app-stores-search',
  templateUrl: './stores-search.component.html',
  styleUrls: ['./stores-search.component.css']
})
export class StoresSearchComponent implements OnInit {
  strcode = '' ;
  strdesc1 = '' ;
  strdesc2 = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = '2022-01-01' ;

  storesList: LkpStoresModel[] = [];
  @Output() submitClicked = new EventEmitter<any>();

  constructor(public storesservice : LkpStoresService,
              public storage: LocalStorageService,
              private dialogref: MatDialog,
              public stores : LkpStoresModel) { }

  ngOnInit(): void {
    this.retriveStoresLookupTop();
  }
  retriveStoresLookupTop(){
    this.storesList = [];
    this.storesservice.LkpStoresLookupTop(this.storage.retrieve('stgcompcode')).subscribe((data: LkpStoresModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.storesList[i] = data[i];
      }
  });
 }
  retriveIPrepLookUp(){}
  Selectstore(Rom : LkpStoresModel){
    this.stores.strcode = Rom.strcode
    this.stores.strdesc1 = Rom.strdesc1
    this.stores.strdesc2 = Rom.strdesc2

    this.stores.userid = Rom.userid
    this.stores.modifieddate = Rom.modifieddate
    this.stores.compcode = Rom.compcode
    this.submitClicked.emit(this.stores);
    this.dialogref.closeAll();

  }
}
